import { FontSources } from "store/features/memeGenerator/types/recentlyUsedFont";
import { Font } from "../Font/Font";
import { useFontList } from "../useFontList";

type UseFontListReturn = ReturnType<typeof useFontList>;

interface WebFontsProps {
    webFonts: UseFontListReturn["webFonts"];
    handleClick: UseFontListReturn["handleClick"];
}

export const WebFonts = ({ webFonts, handleClick }: WebFontsProps) => {
    return (
        <>
            {webFonts.length > 0 && (
                <div className="pl-4 text-sm text-irGray-500 border-t border-t-[#f3f3f3] dark:border-t-darkSurface-400 pt-1 mt-2">
                    Web Fonts
                </div>
            )}
            {webFonts.map((font) => (
                <Font key={font} family={font} source={FontSources.WEBFONT} handleClick={handleClick} close={close} />
            ))}
        </>
    );
};
